<template>
    <div class="chat-content">
        <div class="chat-entry chat-entry-event text-secondary">
            <p>
                {{
                    formatDate(entry.createdAt, {
                        month: "numeric",
                        day: "numeric",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                }}
            </p>
        </div>

        <div class="chat-entry chat-entry-event text-secondary" :class="groupDirection === 'out' ? `bg-light` : ''">
            <p>
                {{
                    $t(`team-chats.events.${getEvent().text}`, {
                        date: formatDate(entry.createdAt, {
                            month: "numeric",
                            day: "numeric",
                            year: "numeric",
                        }),
                        time: formatDate(entry.createdAt, {
                            hour: "2-digit",
                            minute: "2-digit",
                        }),
                        payload: getEvent().payload,
                        participant: getEvent().participant,
                        addedBy: getEvent().addedBy,
                    })
                }}
            </p>

            <small v-if="entry.type !== 'event'" class="chat-time">
                {{
                    formatDate(entry.createdAt, {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                }}
            </small>
        </div>
    </div>
</template>

<script>
import { formatDate } from "@/utils/luxon";

export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        groupDirection: {
            type: String,
            required: false,
        },
        formattedActiveChatData: {
            type: Array,
            required: true,
        },
        activeChat: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getMessage() {
            return JSON.parse(this.entry.message);
        },
        getEvent() {
            const message = this.getMessage();
            const type = message.eventType;
            const payload = message.payload;

            const findName = (userId) => {
                if (!Array.isArray(this.activeChat.participants)) {
                    return "";
                }

                const participant = this.activeChat.participants.find((participant) => participant.userId === userId);

                return participant?.user?.name ?? "";
            };

            switch (type) {
                case "TeamChat::participantLeft":
                    return {
                        payload,
                        participant: findName(payload.userId),
                        text: "participant-left",
                    };
                case "TeamChat::participantAdded":
                    return {
                        payload,
                        participant: findName(payload.userId),
                        addedBy: findName(payload.addedBy),
                        text: "participant-added",
                    };
                case "TeamChat::participantRemoved":
                    return {
                        payload,
                        participant: findName(payload.userId),
                        text: "participant-removed",
                    };
                case "TeamChat::chatDeleted":
                    return {
                        payload,
                        text: "chat-deleted",
                    };
                case "TeamChat::groupChatCreated":
                    return {
                        payload,
                        createdBy: findName(payload.createdBy),
                        text: "group-chat-created",
                    };
            }

            return;
        },
    },
    setup() {
        return {
            formatDate,
        };
    },
};
</script>
